import { render, staticRenderFns } from "./EmpresasUni.vue?vue&type=template&id=2f0a7eb9&"
import script from "./EmpresasUni.vue?vue&type=script&lang=js&"
export * from "./EmpresasUni.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasUni.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports